module.exports = __webpack_public_path__ + "img/x7.0ee4fd5a.jpg";